import React, { useState, useEffect } from "react";
import debounce from "lodash.debounce";

import { string, array, shape, arrayOf, bool, object } from "prop-types";

import ListItem from "../../ListItem/ListItem.jsx";

const propTypes = {
  results: arrayOf(
    shape({
      imageSrcWide: string,
      imageSrcSquare: string,
      title: string,
      taxonomy: array,
      contentUrl: string,
    }),
  ),
  focusRef: object,
};

const ThreeUpGrid = (props) => {
  const { results, focusRef } = props;

  const [maxThreeResults, setMaxThreeResults] = useState([]);

  useEffect(() => {
    if (results.length > 3) {
      setMaxThreeResults(results.slice(0,3));
    } else {
      setMaxThreeResults(results);
    }
  }, [results]);

  // no results passed.
  if (!results || results.length < 1) {
    return null;
  }

  return (
    <section className="three-up-grid">
      <div className="three-up-grid__container">
        <div className="three-up-grid__row">
          {maxThreeResults &&
            maxThreeResults.map((result, i) => (
              <div key={i} className="three-up-grid__item">
                {/* To solve "properly sized images" issue we can update the sizes to be 270  but we will need to see if this will affect any other places*/}
                <ListItem
                  {...result}
                  imagePosition=""
                  media={i % 2 === 0 ? result.imageSrcSquare : result.imageSrcWide}
                  sizes={i % 2 === 0 ? "570px" : "270px"}
                  link={{
                    href: result.contentUrl,
                    text: "",
                  }}
                  focusRef={i === 0 ? focusRef : null}
                />
              </div>
            ))}
        </div>
      </div>
    </section>
  );
};

ThreeUpGrid.propTypes = propTypes;
export default ThreeUpGrid;
